exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-merchant-table_buttons>button:first-child{margin-right:15px}", ""]);

// exports
